import type { CustomIconProps } from '../CustomIcon';

export const ExternalLinkSmallIcon = ({
  color,
  size = 17,
  secondaryColor,
  ternaryColor,
  solid,
  ...props
}: CustomIconProps) => (
  <svg width={size} height={size} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M12.5 9.16667V13.1667C12.5 13.5203 12.3595 13.8594 12.1095 14.1095C11.8594 14.3595 11.5203 14.5 11.1667 14.5H3.83333C3.47971 14.5 3.14057 14.3595 2.89052 14.1095C2.64048 13.8594 2.5 13.5203 2.5 13.1667V5.83333C2.5 5.47971 2.64048 5.14057 2.89052 4.89052C3.14057 4.64048 3.47971 4.5 3.83333 4.5H7.83333'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path d='M10.5 2.5H14.5V6.5' stroke={color} strokeLinecap='round' strokeLinejoin='round' />
    <path
      d='M7.16675 9.83333L14.5001 2.5'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
